module.exports = __webpack_public_path__ + "img/light-bulb.cb6faa8e.svg";